import { StatCard } from '../../../ui'

export interface tileProps {
    title: string
    stat: string
    /** Deprecated: tiles no longer carry a coloured bar. Kept for compatibility. */
    accentColor?: string
}

/** Legacy KPI tile. New code should use `StatCard` / `StatGrid` from `ui`. */
export const StatTile = ({ title, stat }: tileProps) => <StatCard label={title} value={stat} />
